import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urljoin from "url-join";

export enum UserListSortField {
  employeeId = "employeeId",
  user_group = "user_group",
  bu = "bu",
  sale_organization = "sale_organization",
  sale_group = "sale_group",
  first_name = "first_name",
  last_name = "last_name"
}

export const userManagementSection = "/user-management";
export const userCreateSection = `${userManagementSection}/create`;

export type UserListUrlSort = Sort<UserListSortField>;
export type UserListUrlQueryParams = Pagination & UserListUrlSort;

export const UserListUrl = (params?: UserListUrlQueryParams) =>
  userManagementSection + "?" + stringifyQs(params);

export const userDetailPath = (id: string) =>
  urljoin(userManagementSection, id);

export const userDetailUrl = (id: string, params?: any) =>
  userDetailPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
